import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { Box, CircularProgress, FormControlLabel, Switch, Typography } from '@mui/material';
import { useState } from 'react';
import { defineMessage, FormattedMessage } from 'react-intl';
import { useFragment } from '../../../hooks/useFragment';
import { SubtitleDownloadBtns } from './SubtitleDownloadBtns';
import { useFragmentSubtitleDownloadUrls } from './useFragmentSubtitleDownloadUrls';

const subtitlesTitleMessage = defineMessage({
  id: 'fragments.subtitlesStatus.title',
  defaultMessage: 'Subtítulos',
});

/**
 * Subtitle export section on the Files tab.
 * Download actions are available only after transcription completes.
 */
export function FragmentSubtitlesFiles() {
  const { fragment } = useFragment();
  const [speakerIdCheck, setSpeakerIdCheck] = useState(false);
  const isTranscriptionReady = fragment.transcriptionCompletedAt !== null;
  const downloadUrls = useFragmentSubtitleDownloadUrls(
    isTranscriptionReady ? fragment.id : undefined,
    speakerIdCheck,
  );

  return (
    <ContentCluster message={subtitlesTitleMessage}>
      {!isTranscriptionReady ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={16} />
          <Typography variant="body2" color="text.secondary">
            <FormattedMessage
              id="fragments.viewScreen.transcriptionNotReadyTooltip"
              defaultMessage="Esperando por transcripción de fragmento"
            />
          </Typography>
        </Box>
      ) : (
        <>
          <SubtitleDownloadBtns downloadUrls={downloadUrls} />
          <FormControlLabel
            control={
              <Switch
                size="small"
                color="primary"
                checked={speakerIdCheck}
                onChange={(_event, checked) => {
                  setSpeakerIdCheck(checked);
                }}
              />
            }
            label={
              <FormattedMessage
                id="fragments.subtitlesStatus.add"
                defaultMessage="Agregar ID de speaker"
              />
            }
            sx={{
              mt: 2,
              '& .MuiFormControlLabel-label': { typography: 'body2' },
            }}
          />
        </>
      )}
    </ContentCluster>
  );
}
